import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showTextOverlay } from '../../../actions/textoverlay';
import OptionsSelector from '../OptionsSelector';
import Headline from '../../atoms/Headline';
import { checkInsurance, typeOfInsurance } from '../../../utils';

var AppConfig = require('../../../config.json');

/**
 * A simple OptionsSelectorGroup.
 */
/*
{
	"preview": "image",
	"label": "Gerätefarbe",
	"choices": [{
		"label": "silber/weiß",
		"preview": "http://placekitten.com/200/400",
		"article": "ABC-1000"
	}, {
		"label": "spacegrau/schwarz",
		"preview": "http://placekitten.com/200/400",
		"article": "ABC-1004"
	}, {
		"label": "gold/weiß",
		"preview": "http://placekitten.com/200/400",
		"article": "ABC-1008"
	}]
}
*/
const getLabel = label => {
  var str = label.toLowerCase();
  if(str==='versicherung wg') {
    return "Wertgarantie";
  }
  return label;
}

class OptionsSelectorGroup extends React.Component {
	constructor(props) {
      super(props);
      this.showInfo = this.showInfo.bind(this);
      this.selectChoice = this.selectChoice.bind(this);
      this.isSelected = this.isSelected.bind(this);
      this.state = {
        article: '',
        isset: false
      };
    }


    // shouldComponentUpdate(nextProps, nextState) {
    //   return this.props.pathname===nextProps.pathname;
    // }

    componentWillUpdate(nextProps, nextState) {
      if(nextProps.options.isset) {
      	for (var i = 0; i < this.props.config.choices.length; i++) {
      		if(this.props.options.articles.indexOf(this.props.config.choices[i].article)!==-1) {
      			if(this.state.article!==this.props.config.choices[i].article) {
	      			this.setState({
			          article: this.props.config.choices[i].article,
			          isset: true
			        });
	      		}
		        break;
      		}
      	}
        
      }

    }

    showInfo(type, isGostudent) {
      // console.log("type ",type);
      var overlayObj;
      if(isGostudent) {
        overlayObj = {
          text:AppConfig.gostudentoverlay.text,
          headline:AppConfig.gostudentoverlay.headline,
          download:AppConfig.gostudentoverlay.download,
          downloadStr:AppConfig.gostudentoverlay.downloadStr,
          download2:AppConfig.gostudentoverlay.download2,
          downloadStr2:AppConfig.gostudentoverlay.downloadStr2
        };
      } else {
        overlayObj = {
          text:AppConfig.insuranceoverlay[type].text,
          headline:AppConfig.insuranceoverlay[type].headline,
          download:AppConfig.insuranceoverlay[type].download,
          downloadStr:AppConfig.insuranceoverlay[type].downloadStr,
          download2:AppConfig.insuranceoverlay[type].download2,
          downloadStr2:AppConfig.insuranceoverlay[type].downloadStr2
        };
      }
      
      this.props.dispatch(showTextOverlay(
        overlayObj
      ));
    }

    selectChoice(choice, id) {
      this.setState({
        article: choice.article,
        isset: true
      });
     this.props.onChange(this.props.group, choice, id);
    }

    isSelected(choice) {
      if(this.props.isSingleChoice) {
        return true;
      }
      return this.props.checkSelect(choice);
    }

    render () {
      const label = getLabel(this.props.config.label);
      // const isInsurance = checkInsurance(this.props.config.label);
      // const typeInsurance = typeOfInsurance(this.props.config.label);
        return (
          <div className="optionsselectorgroup">
            <div className="header">
              <Headline typeOf="h3">{label}</Headline>
            </div>
            <div className="inner">
            	<div className="items">
              		{
              			this.props.config.choices.map((choice, n) => <OptionsSelector showInfo={this.showInfo} isGostudent={choice.gostudent} isInsurance={choice.isInsurance} typeOfInsurance={choice.typeOfInsurance} isSingleChoice={this.props.isSingleChoice} ref={`optionsitem_${n}`} key={`optionsitem_${n}`} id={n} choice={choice} type={this.props.config.preview} selected={this.isSelected(choice)} onClick={this.selectChoice} />)
              		}
              	</div>
            </div>
          </div>
        );
    }

}

OptionsSelectorGroup.propTypes = {
	/** configuration object */
	config: PropTypes.object.isRequired,
	/** checkSelected */
	checkSelect: PropTypes.func,
	/** Gets called when the user changes a config */
	onChange: PropTypes.func,
  isSingleChoice:PropTypes.bool
}


OptionsSelectorGroup.defaultProps = {
  isSingleChoice: false
  
}

const mapStateToProps = (state) => {
  return {
    options: state.status.options
  }
}
const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsSelectorGroup)






// WEBPACK FOOTER //
// ./src/components/molecules/OptionsSelectorGroup/OptionsSelectorGroup.js